/**
=========================================================
* Soft UI Dashboard PRO React - v4.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Card from 'atoms/Card'
import { motion } from 'framer-motion'

// Soft UI Dashboard PRO React components
import SoftBox from 'components/SoftBox'
import SoftTypography from 'components/SoftTypography'

// Soft UI Dashboard PRO React example components
import DashboardLayout from 'components/LayoutContainers/DashboardLayout'
import Footer from 'components/Footer'
import DataTable from 'components/Tables/DataTable'

// Data
import dataTableData from 'layouts/applications/data-tables/data/dataTableData'
import investmentReferencesData from 'layouts/applications/data-tables/data/investmentReferencesData'
import financialDisclosuresData from 'layouts/applications/data-tables/data/financialDisclosuresData'
import { Box, Grid, Typography } from '@mui/material'

function DataTables() {
  return (
    <DashboardLayout>
      <Box
        px={{
          xs: 4,
          sm: 4,
          md: 4,
          lg: 6,
          xl: 6,
          xxl: 6,
          test: 6,
          xl3: 6,
        }}
      >
        <Grid container spacing={{ xs: 1, lg: 6 }}>
          <Grid item xs={12} mt={8} display={'flex'}>
            <Typography
              fontWeight="400"
              fontSize="28px"
              textAlign="left"
              color="#262627"
            >
              <Box sx={{ display: 'inline-block', fontWeight: 600 }}>
                Resources
              </Box>{' '}
              - Helpful information to aid in retirement planning
            </Typography>
          </Grid>
          <Grid item xs={12} lg={10}>
            <motion.div
              layout
              initial={{ opacity: 0, scale: 0.95 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.4, ease: 'easeInOut' }}
            >
              <Card>
                <DataTable
                  table={investmentReferencesData}
                  canSearch
                  entriesPerPage={{ defaultValue: 10 }}
                  alternateTableHeader="PARCO Webinars"
                  alternateTableSubHeader="Check out our Webinars below to get more detailed on explanations on your federal benefits and finances."
                />
              </Card>
            </motion.div>
          </Grid>
        </Grid>
      </Box>
    </DashboardLayout>
  )
}

export default DataTables
